import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { saveEmployee, updateEmployee } from './actions';
import TextField from '../../components/common/TextField';
import CheckboxField from '../../components/common/CheckboxField';
import SelectField from '../../components/common/SelectField';
import DropNCropField from '../../components/common/DropNCropField';
import { EMPLOYEE_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class EmployeeForm extends Component {
  onSubmit = formProps => {
    const { lang } = formProps;
    const { config } = this.props;

    const employeeRequestData = {
      name: formProps.name,
      surname: formProps.surname,
      content: formProps.content,
      job: formProps.job,
      jobType: formProps.jobType,
      email: formProps.email,
      telephone: formProps.telephone,
      photo: formProps.photo.result,
      jobDescription: formProps.jobDescription,
      showOnContact: formProps.showOnContact.toString()
    };

    if (config && config.id) {
      // add new mutation for existing employee
      this.props.updateEmployee(employeeRequestData, config.id, lang, () => {
        this.props.history.push('/zamestnanci');
      });
    } else {
      // create brand new employee
      this.props.saveEmployee(employeeRequestData, lang, () => {
        this.props.history.push('/zamestnanci');
      });
    }
  };

  render() {
    const { config } = this.props;
    const { handleSubmit } = this.props;

    return (
      <div className="new-employee">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            key="lang"
            component={SelectField}
            label="Jazyk"
            name="lang"
            disabled={config ? config.disableSelect : false}
            validate={required}
          >
            <option value="" key="empty">
              Vyberte jazyk
            </option>
            <option value="cs" key="cs">
              CZ
            </option>
            <option value="en" key="en">
              EN
            </option>
          </Field>
          <Field
            component={TextField}
            type="text"
            label="Jméno"
            name="name"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Příjmení"
            name="surname"
            validate={required}
          />
          <Field
            component={DropNCropField}
            label="Foto"
            name="photo"
            validate={required}
            minCropBoxWidth={128}
            aspectRatio={1 / 1}
          />
          <Field
            component={TextField}
            type="text"
            label="Pozice"
            name="job"
            validate={required}
          />
          <Field
            key="jobType"
            component={SelectField}
            label="Typ úvazku"
            name="jobType"
          >
            <option value="f" key="empty">
              Vyberte typ úvazku
            </option>
            <option value="a_doctor" key="doctor">
              Doktor
            </option>
            <option value="c_nurse" key="nurse">
              Sestra
            </option>
            <option value="d_receptionist" key="receptionist">
              Recepční
            </option>
            <option value="b_hygienist" key="hygienist">
              Hygienista
            </option>
            <option value="e_manager" key="manager">
              Manažer
            </option>
          </Field>
          <Field
            component={TextField}
            type="text"
            label="Email"
            name="email"
            placeholder="email"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Telefon"
            name="telephone"
            placeholder="telefon"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="O zaměstnanci"
            name="jobDescription"
            validate={required}
          />
          <Field
            component={CheckboxField}
            label="Zobrazit v kontaktech"
            name="showOnContact"
            checked
          />
          <div className="form-buttons">
            <Button color="primary">Uložit</Button>
            <Button tag={Link} to="/zamestnanci" color="danger">
              Zpět na zaměstnance
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveEmployee,
  updateEmployee
};

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  ),
  reduxForm({ form: EMPLOYEE_FORM_NAME })
)(EmployeeForm);



// WEBPACK FOOTER //
// ./src/modules/EmployeeForm/index.js